import React from 'react';
import ObservacionComponent from './Observacion';

const Observacion = ({ idCurriculum, showProcess }) => {

    // Validations
    const validationMessages = {
        observacion: [
            {
                type: 'required',
                message: 'Favor ingresar alguna observacion',
            },
            {
                type: 'maxLength',
                message: 'Las observaciones no pueden exceder los 200 caracteres',
            },
            {
                type: 'minLength',
                message: 'Las observaciones no pueden tener menos de 20 caracteres',
            }
        ]
    };

    return (
        <div style={{background: "white"} }>
            <ObservacionComponent validationMessages={validationMessages} idCurriculum={idCurriculum} showProcess={showProcess} />
        </div>
    );
};

export default Observacion;
